import React from 'react';
import clsx from 'clsx';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { useStyles } from './styles';
import EventCardBanner from '../../shared/event-card-banner';
import { OfferingHeaderProps } from './interface';

const OfferingHeader = ({
  offeringType,
  eventTypeLabel,
  showRecommended,
  hideBanners,
}: OfferingHeaderProps) => {
  const { t } = useTranslation();
  const classes = useStyles({ offeringType });

  return (
    <>
      {!hideBanners && (
        <Box
          className={clsx(
            classes.recommended,
            !showRecommended && classes.hide,
          )}
        >
          {t('v2.global.label_recommendedForYou')}
        </Box>
      )}

      <EventCardBanner
        offeringType={offeringType}
        eventTypeLabel={eventTypeLabel}
      />
    </>
  );
};

export default OfferingHeader;
